export const QuoteStatuses = {
  Accepted: 'Accepted',
  Declined: 'Declined',
  Viewed: 'Viewed',
  ChangesRequested: 'Changes Requested'
};

export const enUS = 'en-US';
export const esMX = 'es-MX';
export const enGB = 'en-GB';

export const SupportedCultures = [enUS, enGB, esMX];

export const TranslationIDs = {
  FeedbackModelInvalidError: 'feedbackmodelinvalid',
  UnexpectedError: 'unexpectederroroccurred',
  ViewAttachments: 'viewattachments',
  documents: 'documents'
};

export enum DialogNames {
  SendFeedback = 'SendFeedback',
  FeedbackConfirmed = 'AcceptQuote'
}

export const AnalyticsEventKeys = {
  AcceptClicked: 'AcceptButtonClicked',
  DeclineClicked: 'DeclineButtonClicked',
  RequestChangesClicked: 'RequestChangesButtonClicked',
  PayNowClicked: 'PayNowButtonClicked',
  AcceptCancelClicked: 'AcceptCancelButtonClicked',
  DeclineCancelClicked: 'DeclineCancelButtonClicked',
  RequestChangesCancelClicked: 'RequestChangesCancelButtonClicked',
  AcceptConfirmClicked: 'AcceptConfirmButtonClicked',
  DeclineConfirmClicked: 'DeclineConfirmButtonClicked',
  RequestChangesConfirmClicked: 'RequestChangesConfirmButtonClicked',
  DocumentsMenuClicked: 'DocumentsMenuButtonClicked',
  DownloadAllClicked: 'DownloadAllButtonClicked',
  DownloadDocumentClicked: 'DownloadDocumentButtonClicked',
  PayNowAttempted: 'PayNowAttempted',
  FinancingApplicationAttempted: 'FinancingApplicationAttempted'
};
